import type { Fields } from "../../form-correction-table";
import ValueDisplay from "../../common/value-display";

export default function Interoperability({
  field,
  filledFieldId,
  value,
  isOldValue,
}: Readonly<{
  field: Fields;
  filledFieldId: string;
  value: Record<string, string>;
  isOldValue?: boolean;
}>) {
  return (
    <div className="flex flex-col gap-1">
      {field.config.input_field.map(
        (inputField: { name: string; label: string }) => {
          const { name, label } = inputField;
          return (
            <div key={`${filledFieldId}- ${name}`} className="flex flex-col">
              <span className="text-xs text-info font-semibold">{label}:</span>
              <ValueDisplay isOldValue={isOldValue}>
                {String(value[name] ?? "—")}
              </ValueDisplay>
            </div>
          );
        },
      )}
    </div>
  );
}
